import BrButton from '@govbr/react-components/lib/BrButton';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import imgMoca1 from '../../../assets/img/como-cadastrar-moca1.svg';
import imgMoca2 from '../../../assets/img/como-cadastrar-moca2.svg';
import imgPagina1 from '../../../assets/img/tutorial-pre-cadastro-pagina1.svg';
import imgPagina2 from '../../../assets/img/tutorial-pre-cadastro-pagina2.svg';
import auth from '../../../auth/Auth';
import { trackServiceSelect } from '../../../common/tracker';
import Card from '../../../components/Card/Card';
import {
  getPermiteRemoverFamiliaCadUnico,
  selectPerfilCompleto,
  selectPermiteRemoverPreFamiliaCadUnico,
  selectSituacaoCadastroFamilia,
} from '../../Perfil/perfilSlice';
import styles from './TutorialExcluirCadastro.module.css';

export const mostrarExclusaoCadastral = (history) => {
  if (localStorage.getItem('enviar-para-home') === 'true') {
    history.push('/home');
    return;
  }
  localStorage.setItem('enviar-para-home', 'false');
  localStorage.setItem('cadunico/redirect', '/exclusaoCadastral');
  trackServiceSelect('POR-MENU', 'EXCLUSÃO CADASTRAL');
  history.push('/exclusaoCadastral');
};

const TutorialExcluirCadastro: React.FC<any> = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const permiteRemoverPreFamiliaCadUnico = useAppSelector(selectPermiteRemoverPreFamiliaCadUnico);

  const [page, setPage] = useState(1);

  useEffect(() => {
    if (auth.isAuthenticated() && perfil && perfil.numeroFamiliar) {
      dispatch(
        getPermiteRemoverFamiliaCadUnico({
          cpf: auth.getUser(),
          numeroFamiliar: perfil.numeroFamiliar,
        })
      );
    }
  }, [dispatch, perfil]);

  const pagina1 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>ATENÇÃO</div>
        </div>
        <div className={styles.content}>
          <div className={`${styles.text} ${styles.small}`}>
            <strong>Os órgãos de fiscalização avisam que muitas pessoas entraram no
              Cadastro Único de forma errada e fora da lei.</strong> Muitas pessoas se
            cadastraram sozinhas, mas na verdade moram com suas famílias.
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Isso aconteceu, porque acharam que o benefício do Bolsa Família era para
            cada pessoa. Mas, pela lei, <strong>o Bolsa Família sempre foi um benefício
            por família.</strong>
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Lembre que <strong>cada família que tem dois benefícios do Bolsa Família faz
            com que uma família pobre fique sem nenhum benefício.</strong>
          </div>

          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(2)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={`${styles.bulletPoint} ${styles.selecionado}`} />
              <div onClick={() => setPage(2)} className={styles.bulletPoint} />
            </div>
          </div>
        </div>
        <div className={styles.footerImage}>
          <img className={styles.imgPagina1} src={imgPagina1} alt="Imagem do rodapé" />
          <img className={styles.imgMoca1} src={imgMoca1} alt="Mulher em pé" />
        </div>
      </div>
    </div>
  );

  const pagina2 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>ATENÇÃO</div>
        </div>
        <div className={styles.content}>
          <div className={`${styles.text} ${styles.small}`}>
            <strong>Se você se cadastrou errado, cancele o seu cadastro.</strong>
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Depois, sem pressa, pode agendar novo cadastramento a partir de julho de 2023, e então
            se incluir corretamente no cadastro de sua família. Com isso, vai poder ter acesso a
            vários programas sociais!
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Se você mora sozinho mesmo, está tudo certo. Não precisa fazer nada neste momento.
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            <strong>Quem não corrigir o cadastro de forma voluntária, será convocado e poderá
              ser responsabilizado.</strong>
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Contamos com você, para fazer as coisas do jeito certo!
          </div>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => mostrarExclusaoCadastral(history)}>
              Concluir
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={styles.bulletPoint} />
              <div onClick={() => setPage(2)} className={`${styles.bulletPoint} ${styles.selecionado}`} />
            </div>
          </div>
        </div>
        <div className={styles.footerImage}>
          <img className={styles.imgPagina2} src={imgPagina2} alt="Imagem do rodapé" />
          <img className={styles.imgMoca2} src={imgMoca2} alt="Mulher em pé" />
        </div>
      </div>
    </div>
  );

  return (
    <>
      {page === 1 && pagina1}
      {page === 2 && pagina2}
    </>
  );
};

export default TutorialExcluirCadastro;
